<template>
  <a-tag color="green"
    v-if="status === 'Approved' || status === 'Aktif' || status === 'Verified' || status === 'Transfered' || status === 'Edited' || status === 'Completed'">{{ status.toUpperCase() }}</a-tag>
  <a-tag color="blue" v-else-if="status === 'Delivered' || status === 'Closed'">{{ status.toUpperCase() }}</a-tag>
  <a-tag color="orange" v-else-if="status === 'On Process' || status === 'Waiting' || status === 'Not Completed'">{{ status.toUpperCase() }}</a-tag>
  <a-tag color="red"
    v-else-if="status === 'Rejected' || status === 'Revised' || status === 'Non Aktif' || status === 'Cancelled'">{{ status.toUpperCase() }}</a-tag>
  <a-tag v-else-if="status === 'Draft'">{{ status.toUpperCase() }}</a-tag>
  <a-tag v-else-if="status === 'Libur Nasional' || status === 'Cuti Bersama'"
    color="red">{{ status.toUpperCase() }}</a-tag>
  <a-tag v-else-if="status === 'Event'" color="green">{{ status.toUpperCase() }}</a-tag>
  <a-tag color="red" v-else-if="status === null">CORRUPT</a-tag>
</template>

<script>
export default {
  name: "status",
  props: {
    status: String
  }
};
</script>
